// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b8d2195d","885":"cd2c8d3b"}[chunkId] + ".chunk.js";
};